/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_Marked_Shipped_LabelInputs */

const en_samples_marked_shipped_label = /** @type {(inputs: Samples_Marked_Shipped_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marked shipped`)
};

const es_samples_marked_shipped_label = /** @type {(inputs: Samples_Marked_Shipped_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcada(s) como enviada(s)`)
};

/**
* | output |
* | --- |
* | "Marked shipped" |
*
* @param {Samples_Marked_Shipped_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_marked_shipped_label = /** @type {((inputs?: Samples_Marked_Shipped_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_Marked_Shipped_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_marked_shipped_label(inputs)
	return es_samples_marked_shipped_label(inputs)
});